import axios from 'axios';
import {Message, MessageBox, Loading} from 'element-ui';

const service = axios.create({
    // baseURL: process.env.VUE_APP_API_URL,
    baseURL: 'https://sx.jxbashen.com',
    timeout: 15000
});

var loading = null;
let MessageBoxIsShow = false;
service.interceptors.request.use(
    config => {
        // post、put请求加上loading，---配置不是这post、put请求加上loading
        if (config.method === 'post' || config.method === 'put' || config.loading) {
            loading = Loading.service({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        }
        return config;
    },
    error => {
        if (loading) loading.close();
        return Promise.reject();
    }
);

export default service;
